














import { Component, Vue } from 'vue-property-decorator';
import Desk from '@/components/room/virtualSpace/Desk.vue';
import Avatar from '@/components/room/virtualSpace/avatar/Avatar.vue';
import { store } from '@/utils/store';

@Component({
  components: {
    Desk,
    Avatar,
  },
})
export default class VirtualSpace extends Vue {
  get users() {
    return store.users;
  }
}
